const lang = `en`
const name = `Click Therapeutics`
const shortName = `ClickThera`
const title = `Click Therapeutics`
const titlePattern = `[PAGE_TITLE] | [SITE_NAME]`
const description = `A biotechnology company that develops, validates, and commercializes software as prescription medical treatments for people with unmet medical needs.`
const colorMain = `#7f522c`
const colorBg = `#fffcf3`
const themeColorDark = `#333`
const themeColorLight = `#333`
const socialImage = `/meta-images/social.jpg`
// const icon = `/meta-images/icon-transparent.png` // favicon, ms tile
const icon = `/meta-images/icon-with-bg.png` // favicon, ms tile
const iconBgColor = colorBg
const iconWithBg = `/meta-images/icon-with-bg.png` // apple touch, webmanifest
const favIcon = icon
const maskIcon = `/meta-images/mask-icon.svg` // https://developer.apple.com/library/archive/documentation/AppleApplications/Reference/SafariWebContent/pinnedTabs/pinnedTabs.html
const maskIconColor = colorMain
const fbAppId = ``
const twitterHandle = `@ClickThera`
const robotsNoFollow = false
const robotsNoIndex = false
const siteUrl = `https://www.clicktherapeutics.com`

export const siteMetadata = {
  lang,
  name,
  title,
  titlePattern,
  description,
  socialImage,
  fbAppId,
  twitterHandle,
  icon,
  iconBgColor,
  iconWithBg,
  favIcon,
  maskIcon,
  maskIconColor,
  themeColorDark,
  themeColorLight,
  robotsNoFollow,
  robotsNoIndex,
  shortName,
  siteUrl,
  pathPrefix: `../click-therapeutics`, // Remove later @Joan
}
